import { instanceLetter } from '@jackedlogs/shared';

// EQ-1 — how an equipment instance READS. The stored value is a canonical
// English slug on purpose (`machine-b`, never `macchina-b`), because a stored
// identity must not depend on the language of whoever created it; the label
// beside it is the localised half, and this is the one place that turns one
// into the other so the picker tray and the logger card cannot disagree.
//
// A value that did not come from autoInstanceValue renders as itself.
export function machineLabel(
  value: string,
  t: (k: string, opts?: Record<string, unknown>) => string,
): string {
  const letter = instanceLetter(value);
  return letter === null
    ? value
    : t('swap.machineLabel', { letter, defaultValue: `Machine ${letter}` });
}
